import { Reveal } from "@/components/Reveal";
import Logo from "@/components/Logo";

export default function Closing() {
  return (
    <footer className="mx-auto max-w-6xl px-4 sm:px-6 mt-14 mb-16 pt-6 border-t border-hair" data-testid="section-closing">
      <Reveal>
        <div className="grid gap-3">
          <p className="text-[15px] text-coal/90 leading-relaxed max-w-3xl">
            There's more we can explore together in the working session &mdash; the portal,
            the open decisions and the week 1 sandbox test. Let us know a time that works
            for your team and we'll lock it in.
          </p>
          <div className="flex items-center gap-3">
            <Logo className="h-5 w-auto" />
            <span className="text-[14px] text-fog">Kaustubh, Prodigitas</span>
          </div>
        </div>
      </Reveal>
    </footer>
  );
}
